/* eslint-disable camelcase */
import { useParams } from 'react-router-dom';
import { useEffect, useRef } from 'react';

import * as Pioneer from 'pioneer';

import { nisarStore } from '../managers/globalState';
import globalRefs from '../managers/globalRefs';
import { getNisarByExternalId } from '../data/nisar';
import { loadNisar } from '../helpers/processNisar';
import { hideLoading, showLoading } from '../components/loading';

const NisarDetail = () => {
	const { nisarParam } = useParams();
	const isLoading = useRef(null);
	const currentNisar = getNisarByExternalId(nisarParam);

	useEffect(() => {
		const { pioneer } = globalRefs;
		const { external_id, type } = currentNisar || {};
		const alreadyLoading = isLoading.current === external_id;

		if (!currentNisar || alreadyLoading) {
			return;
		}

		isLoading.current = external_id;

		const loadType = 'event';
		showLoading(loadType);

		nisarStore.setGlobalState({ currentNisar });

		const patchComponent = pioneer.getScene('main').getEntity('earth').getComponent(Pioneer.SpheroidLODComponent, 'patch');

		loadNisar(currentNisar)
			.then(() => {
				if (isLoading.current) {
					hideLoading(loadType);
				}

				isLoading.current = false;
			}).catch(e => e);

		return () => {
			if (type === 'geoLocated') {
				patchComponent?.setEnabled?.(false);
			}
		};
	}, [currentNisar]);

	useEffect(() => () => {
		const { pioneer } = globalRefs;
		const patchComponent = pioneer.getScene('main').getEntity('earth').getComponent(Pioneer.SpheroidLODComponent, 'patch');

		isLoading.current = null;
		hideLoading('event');

		patchComponent.setEnabled(false);
		nisarStore.setGlobalState({ currentNisar: null });
	}, []);

	return null;
};

export default NisarDetail;
